export const en = {
    clear: "Clear",
    today: "Today",
    now: "Now",
    placeholders: {
        year: "YYYY",
        month: "YYYY-MM",
        date: "YYYY-MM-DD",
        dateTime: "YYYY-MM-DD hh:mm",
    },
};
//# sourceMappingURL=en.js.map